import { fetchFromAPI } from "./fetch-from-api";

export const createPaymentLink = async (
  tonnes: any,
  calculatedPrice: number,
  username: string,
  displayName: string
) => {
  return await fetchFromAPI("/payments/create-payment-link", {
    body: JSON.stringify({
      tonnes,
      calculatedPrice,
      username,
      displayName,
    }),
    method: "POST",
  });
};

export const deactivatePaymentLink = async (
  sessionId: string,
  userId: string
) => {
  return await fetchFromAPI("/payments/deactivate-payment-link", {
    body: JSON.stringify({
      sessionId,
      userId,
    }),
    method: "POST",
  });
};
